storeWriter